<template>
  <div>
    <b-card no-body class="border-none p-4 mb-4">
      <div class="grid grid-cols-4 gap-4">
        <b-card
          title="Card Title"
          tag="article"
          class="mb-2"
          no-body
          v-for="(item, index) in discovercards"
          :key="'item-' + index"
        >
          <img :src="item.image" class="h-100px w-full rounded-t-md" />
          <div class="p-3">
            <b-card-text>
              <h2 class="font-semibold mb-1">{{ item.title }}</h2>
              <p class="text-xs text-muted font-normal h-53px">
                {{ item.description }}
              </p>
            </b-card-text>

            <base-button size="sm" class="w-full mt-2" type="primary"
              >Join</base-button
            >
          </div>
        </b-card>
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      discovercards: [
        {
          image: require("../img/1.gif"),
          title: "Dementia Care",
          description: "Lorem ipsum dolor sit amet."
        },
        {
          image: require("../img/2.jpg"),
          title: "Caregiver Support",
          description:
            "    Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          image: require("../img/3.png"),
          title: "Alzheimer's Care",
          description:
            "    Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        },
        {
          image: require("../img/4.jpg"),
          title: "Healthcare",
          description: "    Lorem ipsum dolor sit amet, consectetur."
        }
      ]
    };
  }
};
</script>
